import { type SelectInputProps, SelectInput } from "react-admin";

type Props = Omit<SelectInputProps, "choices">;

const CHOICES = [
  {
    id: "true",
    name: "On",
  },
  {
    id: "false",
    name: "Off",
  },
];

export const OptionalBooleanInput = (props: Props) => (
  <SelectInput
    {...props}
    choices={CHOICES}
    emptyText="Any"
    emptyValue=""
    parse={(value: unknown) => (value === "any" ? null : value)}
  />
);
